export const BASKET_TYPE_IDS = {
  MEALBOX: "550c0ef6-cd4e-487e-9f19-0cc929152497",
  GROCERY: "1f72b8c1-d765-426d-88e3-ec412fb7f4b7",
} as const;
